let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5yC81")).then(() => parcelRequire('g4PUK'));